import React, { useState } from "react";
import ProgressBar from "../Common/ProgressBar";
import RadioButton from "../../../UI/RadioButton";
const Possession = ({ className, slideChange, textHeading, validation, backClick }) => {
  const [checkedQuestionOne, setCheckedQuestionOne] = useState("unchecked");
  const [checkedQuestionTwo, setCheckedQuestionTwo] = useState("unchecked");
  const nextSlide = async (e) => {
    if (e.target.value === "97") {
      setCheckedQuestionOne("checked");
      setCheckedQuestionTwo("unchecked");
      slideChange(e);
    }
    if (e.target.value === "98") {
      setCheckedQuestionOne("unchecked");
      setCheckedQuestionTwo("checked");
      slideChange(e);
    }
  };
  return (
    <>
      <div id="slide6" className={`${className}`}>
        <ProgressBar value="20" />

        <h3> {textHeading} </h3>
        <div className="btn-comm">
          <RadioButton
            value="97"
            name="possession"
            className="radio-button"
            labelName="Yes"
            labelClassName={`option_but   next6 ${checkedQuestionOne}`}
            onClick={nextSlide}
            validation={validation()}
          />

          <RadioButton
            value="98"
            name="possession"
            className="radio-button"
            labelName="No"
            labelClassName={`option_but   next6 ${checkedQuestionTwo}`}
            onClick={nextSlide}
            validation={validation()}
          />
        </div>
        <p className="text-center"><a  className="back01" name="back04" onClick={backClick}> {'<< Previous'} </a></p>
      </div>
    </>
  );
};
export default Possession;
